import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconToolsHoldCurveHoldSizeM from './IconToolsHoldCurveHold_size_m';

const props: CreateIconArguments = {
  l: IconToolsHoldCurveHoldSizeM,
  m: IconToolsHoldCurveHoldSizeM,
  s: IconToolsHoldCurveHoldSizeM,
  xs: IconToolsHoldCurveHoldSizeM,
  name: 'IconToolsHoldCurveHold',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
